import React from "react";
import { FormControl, TextField, Button, Select, MenuItem } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import LoadingSpinner from "../../../Loading/component";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";

export const CohortUpdateDetailsComponent = ({ 
  loading, 
  formData, 
  cohortTypes, 
  handleInputChange, 
  handleCohortTypeChange, 
  errors, 
  handleUpdateCohort 
}) => {
  return (
    <div style={styles.mainContainer}>
      {loading && (
        <div style={styles.loadingOverlay}>
          <LoadingSpinner />
        </div>
      )}
      <Sidebar />
      <div style={styles.contentContainer}>
        <div style={styles.header}>
          <ArrowBack style={styles.backIcon} onClick={() => window.history.back()} />
          <h2 style={styles.heading}>Cohort Update</h2>
        </div>
        <div style={styles.formWrapper}>
          <div style={styles.formScrollContainer}>
            <form style={styles.formContainer}>
              <FormControl fullWidth style={styles.inputContainer}>
                <div style={styles.labelContainer}>
                  <label style={styles.labelAligned}>
                    Cohort Name <span style={{color:"red"}}>*</span>
                  </label>
                </div>
                <TextField
                  name="name"
                  value={formData.name || ""}
                  onChange={handleInputChange}
                  error={!!errors.name}
                  helperText={errors.name}
                  fullWidth
                  variant="standard"
                  placeholder="Enter Cohort Name"
                  required
                  sx={styles.textFieldStyle}
                />
              </FormControl>

              <FormControl fullWidth style={styles.inputContainer}>
                <div style={styles.labelContainer}>
                  <label style={styles.labelAligned}>
                    Cohort Type <span style={{color:"red"}}>*</span>
                  </label>
                </div>
                <Select
                  name="cohortTypeId"
                  value={formData.cohortTypeId}
                  onChange={handleCohortTypeChange}
                  variant="standard"
                >
                  {cohortTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth style={styles.inputContainer}>
                <div style={styles.labelContainer}>
                  <label style={styles.labelAligned}>
                    Cohort Description <span style={{color:"red"}}>*</span>
                  </label>
                </div>
                <TextField
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  fullWidth
                  variant="standard"
                  placeholder="Enter Description"
                  required
                  sx={styles.textFieldStyle}
                />
              </FormControl>

              <FormControl fullWidth style={styles.inputContainer}>
                <div style={styles.labelContainer}>
                  <label style={styles.labelAligned}>
                    Area Name <span style={{color:"red"}}>*</span>
                  </label>
                </div>
                <TextField
                  name="areaName"
                  value={formData.areaName}
                  onChange={handleInputChange}
                  fullWidth
                  variant="standard"
                  placeholder="Enter Area Name"
                  required
                  sx={styles.textFieldStyle}
                />
              </FormControl>

              <FormControl fullWidth style={styles.inputContainer}>
                <div style={styles.labelContainer}>
                  <label style={styles.labelAligned}>Latitude</label>
                </div>
                <TextField
                  name="lat"
                  value={formData.lat}
                  onChange={handleInputChange}
                  fullWidth
                  variant="standard"
                  placeholder="Enter Latitude"
                  sx={styles.textFieldStyle}
                />
              </FormControl>

              <FormControl fullWidth style={styles.inputContainer}>
                <div style={styles.labelContainer}>
                  <label style={styles.labelAligned}>Longitude</label>
                </div>
                <TextField
                  name="lng"
                  value={formData.lng}
                  onChange={handleInputChange}
                  fullWidth
                  variant="standard"
                  placeholder="Enter Longitude"
                  sx={styles.textFieldStyle}
                />
              </FormControl>

              <Button 
                variant="contained" 
                style={styles.submitButton} 
                onClick={handleUpdateCohort}
                fullWidth
              >
                Update
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

// Updated styles with left-aligned labels
const styles = {
  mainContainer: { 
    display: "flex", 
    height: "100vh", 
    backgroundColor: "#F8F9FA",
    fontFamily: "'Poppins', sans-serif"
  },
  loadingOverlay: { 
    position: "fixed", 
    top: 0, 
    left: 0, 
    width: "100vw", 
    height: "100vh", 
    backgroundColor: "rgba(0, 0, 0, 0.5)", 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "center", 
    zIndex: 9999 
  },
  contentContainer: { 
    flex: 1, 
    padding: "2rem", 
    display: "flex", 
    flexDirection: "column",
    overflow: "hidden"
  },
  header: { 
    display: "flex", 
    alignItems: "center", 
    marginBottom: "1.5rem" 
  },
  backIcon: { 
    cursor: "pointer", 
    fontSize: "2rem", 
    marginRight: "0.75rem",
    color: "#333"
  },
  heading: { 
    fontSize: "1.5rem", 
    fontWeight: 600,
    color: "#333",
    margin: 0
  },
  formWrapper: { 
    width: "100%", 
    backgroundColor: "#fff", 
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)", 
    borderRadius: "12px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  },
  formScrollContainer: {
    flex: 1,
    overflowY: "auto",
    padding: "1.5rem"
  },
  formContainer: { 
    width: "100%", 
    maxWidth: "600px", 
    display: "flex", 
    flexDirection: "column", 
    gap: "1.5rem", 
    margin: "0 auto",
    paddingBottom: "1rem"
  },
  inputContainer: { 
    display: "flex", 
    flexDirection: "column", 
   
    gap: "0.5rem",
    width: "100%"
  },
  labelContainer: {
   
    justifyContent: "flex-start",
    width: "100%"
  },
  labelAligned: {
    fontSize: "0.95rem",
    fontWeight: 500,
    color: "#333",
    marginBottom: "0.25rem",
    fontFamily: "Poppins",
    textAlign: "left"
 
  },
  textFieldStyle: {
    "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
    "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
    "& .MuiFormHelperText-root": {
      marginLeft: 0
    }
  },
  submitButton: { 
    backgroundColor: "#14AE78", 
    color: "#FFF", 
    padding: "0.75rem", 
    fontSize: "1rem", 
    fontWeight: 600, 
    borderRadius: "8px",
    marginTop: "1rem",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#0E8E63"
    }
  },

  // Media queries for responsive design
  "@media (max-width: 768px)": {
    contentContainer: {
      padding: "1.5rem"
    },
    formContainer: {
      gap: "1.25rem"
    },
    heading: {
      fontSize: "1.25rem"
    }
  },

  "@media (max-width: 576px)": {
    contentContainer: {
      padding: "1rem"
    },
    formWrapper: {
      borderRadius: "8px"
    },
    formScrollContainer: {
      padding: "1rem"
    },
    formContainer: {
      gap: "1rem"
    },
    labelAligned: {
      fontSize: "0.9rem"
    },
    submitButton: {
      padding: "0.625rem"
    }
  }
};

export default CohortUpdateDetailsComponent;